import React from 'react';

export const RepeatSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M19 12a7 7 0 0 0-7-7c-1.18 0-2.438.352-4.293 2.207l-.671.672c-.482.481-1.128.963-1.77 1.389v.203q.09-.006.182-.029C6.385 9.213 7.498 9 8.4 9h.762a1 1 0 0 1-.004 2H3.5a1 1 0 0 1-1-1V4.334a1 1 0 0 1 2 .01v.778c-.003.897-.215 2-.442 2.93a1 1 0 0 0-.029.182h.203c.426-.642.908-1.288 1.39-1.77l.67-.671C8.439 3.648 10.18 3 12 3a9 9 0 1 1-6.349 15.38 1 1 0 1 1 1.411-1.418A7 7 0 0 0 19 12"
        />
    </svg>
);
